module.exports = __webpack_public_path__ + "static/amare_img_1_h-7669605a892d7d257d35233b8a5d4c17.jpg";